import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@environments/environment";
import {Result} from "@domain/common/http/result";
import {first} from "rxjs/operators";

/**
 * Service de gestion du suivi des relevés de cartes
 *
 * @author Guillaume TRAVOT
 * @date 18/03/2026
 */
@Injectable()
export class SuiviReleveServiceHttp {

    /**
     * Constructeur
     *
     * @param http Service HTTP
     */
    constructor(private http: HttpClient) {}

    /**
     * Obtention de l'historique d'un relevé
     *
     * @param idRacine identifiant de la racine
     */
    getHistory(idRacine: number): Observable<Result> {
        return this.http.post<Result>(
            `${environment.baseUrl}/controller/ImportCA/historyReleve/${idRacine}`,
            null
        ).pipe(first());
    }

    /**
     * Suppression d'un log de réintégration
     *
     * @param idOpeLog identifiant du log à supprimer
     */
    deleteLog(idOpeLog: number): Observable<Result> {
        return this.http.delete<Result>(
            `${environment.baseUrl}/controller/ImportCA/deleteLog/${idOpeLog}`
        ).pipe(first());
    }

    /**
     * Récupération du détail d'une opération carte
     *
     * @param idOpeCarte identifiant de l'opération carte
     */
    getDetailOpeCarte(idOpeCarte: string): Observable<Result> {
        return this.http.get<Result>(
            `${environment.baseUrl}/controller/ImportCA/detailOpeCarte/${idOpeCarte}`
        ).pipe(first());
    }

    /**
     * Réintégration des opérations en erreur d'un lot
     *
     * @param idLot identifiant du lot
     */
    reintegrerLot(idLot: number): Observable<Result> {
        return this.http.post<Result>(
            `${environment.baseUrl}/controller/ImportCA/reintegrerLot/${idLot}`,
            null
        ).pipe(first());
    }
}